import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Navigation } from '../components';
import { fetchUserProfile } from "../utilities/api";

const MobileNavigation = ({ items, classes, moreOption }) => {
  const [user, setUser] = useState({ fullName: "", shortName: "" });
  const [isLoading, setIsLoading] = useState(true);
  const [activePage, setActivePage] = useState(
    items.find((item) => item.active)?.id || null
  );
  const [isMoreOpen, setIsMoreOpen] = useState(false);

    useEffect(() => {
      const loadUser = async () => {
        try {
          const profile = await fetchUserProfile();
  
          if (profile.fullName && profile.shortName) {
            setUser(profile);
          } else {
            console.warn(" Empty profile received. Check API response.");
          }
  
          setIsLoading(false);
        } catch (error) {
          console.error(" Error loading user:", error);
          setIsLoading(false);
        }
      };
  
      loadUser();
    }, []);

  // Ref for "More" container
  const moreContainerRef = useRef(null);

  const handlePageClick = (id) => {
    if (id === 4) {
      setIsMoreOpen((prevState) => !prevState);
    } else {
      setActivePage(id);
      setIsMoreOpen(false);
    }
  };

  const handleOutsideClick = (e) => {
    if (
      moreContainerRef.current &&
      !moreContainerRef.current.contains(e.target)
    ) {
      setIsMoreOpen(false);
    }
  };

  useEffect(() => {
    if (isMoreOpen) {
      document.addEventListener('mousedown', handleOutsideClick);
    } else {
      document.removeEventListener('mousedown', handleOutsideClick);
    }
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isMoreOpen]);

  return (
    <div
      className={`w-full mobile-nav-more-items md:hidden z-10 ${
        isMoreOpen
          ? 'fixed inset-0 flex justify-end flex-col bg-black bg-opacity-50'
          : 'sticky bottom-0'
      }`}
    >
      {isMoreOpen && (
        <div
          ref={moreContainerRef}
          className="px-4 pt-8 pb-4 bg-white-50 rounded-t-10"
        >
          <div className="mb-2 bg-gold-50 rounded-xl">
            <a
              className="flex flex-row justify-between p-3 text-gray-900 hover:text-gold-500"
              href="/"
            >
              <div className="flex flex-row items-center gap-2">
                <div className="flex items-center justify-center w-6 h-6 px-1 py-1 rounded-full bg-gold-500">
                  <span className="font-medium text-[10px] leading-4 text-white-50">
                  {isLoading ? "" : user?.shortName || "??"}
                  </span>
                </div>
                <p className="font-medium text-sm leading-4.5">
                {isLoading ? "Loading..." : user?.fullName || "Unknown User"}
                </p>
              </div>
              <span href="#" className="flex items-center -rotate-90">
                <img
                  src="/media/images/shevron-left-dark.svg"
                  alt="shevron left"
                  className="w-4 h-4"
                />
              </span>
            </a>
          </div>
          <Navigation
            items={moreOption}
            classes={'p-0 pb-0'}
            linkClass="text-gray-800 hover:text-gold-500"
          />
        </div>
      )}
      <div className="flex justify-around px-6 py-4 bg-white-50 shadow-[0_1px_8px_0px_rgba(0,0,0,0.12)]">
        {items.map((item) => (
          <div
            key={item.id}
            className={`w-full text-center ${
              activePage === item.id ? 'active' : ''
            } ${item.id === 4 && isMoreOpen ? 'open' : ''}`}
          >
            {item.id === 4 ? (
              <span
                className="flex flex-col items-center justify-center pt-1.5 group"
                onClick={() => handlePageClick(item.id)}
              >
                <div className="flex items-center justify-center w-7 h-7">
                  {activePage === item.id || (isMoreOpen && item.id === 4) ? (
                    <item.activeIcon className="w-5 h-5 text-gold-600" />
                  ) : (
                    <item.defaultIcon className="w-5 h-5 text-gray-600 group-hover:text-gold-600" />
                  )}
                </div>
                <p
                  className={`mt-1 text-xs ${
                    activePage === item.id || (isMoreOpen && item.id === 4)
                      ? 'text-gold-600 font-bold'
                      : 'text-gray-600 font-medium group-hover:text-gold-600 group-hover:font-bold'
                  }`}
                >
                  {item.label}
                </p>
              </span>
            ) : (
              <a
                href={item.href}
                className="flex flex-col items-center justify-center pt-1.5 group"
                onClick={() => handlePageClick(item.id)}
              >
                <div className="flex items-center justify-center w-7 h-7">
                  {activePage === item.id || (isMoreOpen && item.id === 4) ? (
                    <item.activeIcon className="w-5 h-5 text-gold-600" />
                  ) : (
                    <item.defaultIcon className="w-5 h-5 text-gray-600 group-hover:text-gold-600" />
                  )}
                </div>
                <p
                  className={`mt-1 text-xs ${
                    activePage === item.id || (isMoreOpen && item.id === 4)
                      ? 'text-gold-600 font-bold'
                      : 'text-gray-600 font-medium group-hover:text-gold-600 group-hover:font-bold'
                  }`}
                >
                  {item.label}
                </p>
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

MobileNavigation.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
      defaultIcon: PropTypes.elementType.isRequired,
      activeIcon: PropTypes.elementType.isRequired,
    })
  ).isRequired,
};

export default MobileNavigation;